import axios from 'axios';

const api = axios.create({
    baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000',
    headers: {
        'Content-Type': 'application/json',
    },
});

api.interceptors.request.use((config) => {
    const token = localStorage.getItem("token");
    if (token) {
        config.headers.Authorization = `Bearer ${token}`;
    }

    let guestId = localStorage.getItem("guestId");
    if (!guestId) {
        guestId = 'guest_' + Date.now().toString(36) + Math.random().toString(36).substring(2);
        localStorage.setItem("guestId", guestId);
    }
    config.headers["x-guest-id"] = guestId;

    return config;
}, (error) => {
    return Promise.reject(error);
});

export default api;
